import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m6tfqnk7qr: FaireBrandEntity = {
  token: "b_m6tfqnk7qr",
  type: "brand",
  name: "MAYA TX",
  avatarUrl:
    "https://cdn.faire.com/fastly/7077748cb8a1b75f8b0c174caf6e9e389fabb10598e0dc935ceda1d9ae89f2b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/26a084080311e06790a7572ebbb26ffd3bc7c28831898ef849a42cc558368da7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7077748cb8a1b75f8b0c174caf6e9e389fabb10598e0dc935ceda1d9ae89f2b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/26a084080311e06790a7572ebbb26ffd3bc7c28831898ef849a42cc558368da7.jpeg",
  location: "Leander, TX, USA",
  minimumOrderDollars: 138,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Introducing MAYA TX Custom Shirt and DTF Printing - Unleash Creativity with High-Quality Apparel! Our DTF printing tech offers precise, vivid designs on fabrics. Limitless possibilities await - personalized shirts, custom hoodies, and more. We care for the environment, using eco-friendly inks and premium materials. Count on exceptional customer support as we bring your ideas to life. Join us in our passion for design, craftsmanship, and sustainability. Experience the MAYA TX difference today!",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.669Z",
    importedBy: "entity-db-cli",
  },
};
